import { useState, useEffect, useRef, useCallback } from "react";
import { useAuth } from "@context/AuthContext";
import { useRole } from "@hooks/useRole";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, PROFILE_IMG_BASE, FIRM_IMG_BASE } from "@config/env";


const doPost = (ep, fields={}) => { const fd=new FormData(); Object.entries(fields).forEach(([k,v])=>{ if(v!=null) fd.append(k,v); }); return axios.post(`${API_BASE}${ep}`,fd).catch(()=>({data:null})); };

const connectiqChat        = (userSlug,message,scope,sessionId) => { const fd=new FormData(); fd.append("user_slug",userSlug); fd.append("message",message); fd.append("scope",scope); if(sessionId) fd.append("session_id",sessionId); return axios.post(`${API_BASE}connectiq/chat`,fd).catch(()=>({data:null})); };
const connectiqGetSessions = (userSlug) => doPost("connectiq/get_sessions",{user_slug:userSlug});
const connectiqGetMessages = (userSlug,sessionId) => doPost("connectiq/get_messages",{user_slug:userSlug,session_id:sessionId});
const connectiqDeleteSession = (userSlug,sessionId) => doPost("connectiq/delete_session",{user_slug:userSlug,session_id:sessionId});

const groupSessionsByDate = (sessions) => {
  const today = new Date().toDateString();
  const yesterday = new Date(Date.now() - 86400000).toDateString();
  const groups = { Today: [], Yesterday: [], Earlier: [] };
  sessions.forEach((s) => {
    const d = new Date(s.updated_at).toDateString();
    if (d === today) groups.Today.push(s);
    else if (d === yesterday) groups.Yesterday.push(s);
    else groups.Earlier.push(s);
  });
  return groups;
};

const formatTime = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });

const renderTextContent = (text) =>
  (text || "").split("\n").map((line, i) => (
    <p key={i} style={{ margin: "3px 0", lineHeight: "1.6" }}>
      {line || <br />}
    </p>
  ));

const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

const AVATAR_COLORS = [
  { bg: "var(--fc-purple-light)", color: "var(--fc-purple-text)" },
  { bg: "var(--fc-green-light)", color: "var(--fc-green-text)" },
  { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)" },
  { bg: "var(--fc-red-light)", color: "var(--fc-red-text)" },
  { bg: "var(--fc-cyan-light)", color: "var(--fc-cyan-text)" },
];

const BADGE_STYLES = {
  "Best fit": { bg: "var(--fc-purple-light)", color: "var(--fc-purple-text)" },
  "Strong fit": { bg: "var(--fc-green-light)", color: "var(--fc-green-text)" },
  "Good fit": { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)" },
};

// ── New Services Result (UC7) ─────────────────────────────────────────────────

const READINESS_STYLES = {
  ready: { bg: "var(--fc-green-light)", color: "var(--fc-green-text)", label: "Ready now" },
  "near-ready": { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)", label: "Near ready" },
  "requires-investment": {
    bg: "var(--fc-red-light)",
    color: "var(--fc-red-text)",
    label: "Requires investment",
  },
};

const VALUE_STYLES = {
  high: { bg: "var(--fc-purple-light)", color: "var(--fc-purple-text)" },
  medium: { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)" },
  low: { bg: "var(--fc-bg-light)", color: "var(--fc-text-muted)" },
};

const NewServicesResult = ({ data }) => (
  <div style={{ fontSize: "13px", maxWidth: "100%" }}>
    {data.summary && (
      <p
        style={{
          color: "var(--fc-text-secondary)",
          marginBottom: "16px",
          lineHeight: "1.7",
          fontSize: "13.5px",
        }}
      >
        {data.summary}
      </p>
    )}

    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {/* Services */}
      {data.services?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "1px solid var(--fc-border-strong)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color:"var(--fc-text-primary)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>🚀</span> New Service Opportunities
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {data.services.map((svc, i) => {
              const rd =
                READINESS_STYLES[svc.readiness] ||
                READINESS_STYLES["near-ready"];
              const vl =
                VALUE_STYLES[svc.potential_value] || VALUE_STYLES.medium;
              return (
                <div
                  key={i}
                  style={{
                    padding: "12px 14px",
                    background: "var(--fc-bg-light)",
                    borderRadius: "8px",
                    border: "0.5px solid var(--fc-border-light)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      marginBottom: "6px",
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13.5px",
                          color:"var(--fc-text-primary)",
                        }}
                      >
                        {svc.name}
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "var(--fc-text-subtle)",
                          marginTop: "1px",
                        }}
                      >
                        {svc.category}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexShrink: 0,
                        marginLeft: "10px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "10px",
                          padding: "3px 8px",
                          borderRadius: "100px",
                          fontWeight: "500",
                          background: vl.bg,
                          color: vl.color,
                        }}
                      >
                        {svc.potential_value} value
                      </span>
                      <span
                        style={{
                          fontSize: "10px",
                          padding: "3px 8px",
                          borderRadius: "100px",
                          fontWeight: "500",
                          background: rd.bg,
                          color: rd.color,
                        }}
                      >
                        {rd.label}
                      </span>
                    </div>
                  </div>

                  {svc.description && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "var(--fc-text-muted)",
                        marginBottom: "8px",
                        lineHeight: "1.5",
                      }}
                    >
                      {svc.description}
                    </div>
                  )}

                  {svc.required_capabilities?.length > 0 && (
                    <div style={{ marginBottom: "8px" }}>
                      <div
                        style={{
                          fontSize: "10px",
                          color: "var(--fc-text-subtle)",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                          marginBottom: "4px",
                        }}
                      >
                        Capabilities available
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {svc.required_capabilities.map((cap, ci) => (
                          <span
                            key={ci}
                            style={{
                              fontSize: "10.5px",
                              padding: "3px 8px",
                              borderRadius: "100px",
                              background: "var(--fc-green-light)",
                              color: "var(--fc-green-text)",
                              fontWeight: "500",
                            }}
                          >
                            {cap}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {svc.key_people?.length > 0 && (
                    <div
                      style={{ marginBottom: svc.readiness_note ? "8px" : "0" }}
                    >
                      <div
                        style={{
                          fontSize: "10px",
                          color: "var(--fc-text-subtle)",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                          marginBottom: "4px",
                        }}
                      >
                        Who can deliver this
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {svc.key_people.map((p, pi) => (
                          <span
                            key={pi}
                            style={{
                              fontSize: "10.5px",
                              padding: "3px 9px",
                              borderRadius: "100px",
                              background: "var(--fc-purple-light)",
                              color: "var(--fc-purple-text)",
                              fontWeight: "500",
                            }}
                          >
                            {p}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {svc.readiness_note && (
                    <div
                      style={{
                        fontSize: "11.5px",
                        color: "var(--fc-text-subtle)",
                        borderLeft: "2px solid var(--fc-border-light)",
                        paddingLeft: "9px",
                        lineHeight: "1.5",
                        marginTop: "8px",
                      }}
                    >
                      {svc.readiness_note}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Capability gaps */}
      {data.capability_gaps?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "0.5px solid var(--fc-border-light)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "var(--fc-amber-text)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>⚡</span> Almost Possible — One Gap Away
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {data.capability_gaps.map((gap, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  padding: "10px 12px",
                  background: "var(--fc-bg-light)",
                  borderRadius: "8px",
                  border: "0.5px solid var(--fc-border-light)",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "var(--fc-amber-text)",
                    flexShrink: 0,
                    marginTop: "5px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color:"var(--fc-text-primary)",
                      marginBottom: "2px",
                    }}
                  >
                    {gap.service}
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "var(--fc-text-subtle)",
                      lineHeight: "1.5",
                    }}
                  >
                    Missing:{" "}
                    <span style={{ color: "var(--fc-amber-text)", fontWeight: "500" }}>
                      {gap.missing}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Recommendation */}
      {data.recommendation && (
        <div
          style={{
            background: "var(--fc-purple-light)",
            border: "0.5px solid var(--fc-purple-border)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "#6C63FF",
              marginBottom: "6px",
            }}
          >
            Connect IQ Recommendation
          </div>
          <div style={{ fontSize: "13px", color: "var(--fc-text-secondary)", lineHeight: "1.7" }}>
            {data.recommendation}
          </div>
        </div>
      )}
    </div>
  </div>
);

// ── Hidden Skills Result (UC6) ────────────────────────────────────────────────

const OPPORTUNITY_STYLES = {
  high: { bg: "var(--fc-green-light)", color: "var(--fc-green-text)", label: "High opportunity" },
  medium: { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)", label: "Medium opportunity" },
  low: { bg: "var(--fc-bg-light)", color: "var(--fc-text-muted)", label: "Low opportunity" },
};

const HiddenSkillsResult = ({ data }) => (
  <div style={{ fontSize: "13px", maxWidth: "100%" }}>
    {data.summary && (
      <p
        style={{
          color: "var(--fc-text-secondary)",
          marginBottom: "16px",
          lineHeight: "1.7",
          fontSize: "13.5px",
        }}
      >
        {data.summary}
      </p>
    )}

    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {/* Hidden / Underutilized Skills */}
      {data.hidden_skills?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "1px solid var(--fc-border-strong)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color:"var(--fc-text-primary)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>💡</span> Underutilized Skills
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {data.hidden_skills.map((item, i) => {
              const opp =
                OPPORTUNITY_STYLES[item.opportunity_level] ||
                OPPORTUNITY_STYLES.medium;
              return (
                <div
                  key={i}
                  style={{
                    padding: "12px 14px",
                    background: "var(--fc-bg-light)",
                    borderRadius: "8px",
                    border: "0.5px solid var(--fc-border-light)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      marginBottom: "6px",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color:"var(--fc-text-primary)",
                        }}
                      >
                        {item.skill}
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "var(--fc-text-subtle)",
                          marginTop: "2px",
                        }}
                      >
                        {item.category}
                      </div>
                    </div>
                    <span
                      style={{
                        fontSize: "10px",
                        padding: "3px 9px",
                        borderRadius: "100px",
                        fontWeight: "500",
                        flexShrink: 0,
                        background: opp.bg,
                        color: opp.color,
                      }}
                    >
                      {opp.label}
                    </span>
                  </div>

                  {item.candidates?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "5px",
                        marginBottom: "6px",
                      }}
                    >
                      {item.candidates.map((c, ci) => (
                        <span
                          key={ci}
                          style={{
                            fontSize: "10.5px",
                            padding: "3px 9px",
                            borderRadius: "100px",
                            background: "var(--fc-purple-light)",
                            color: "var(--fc-purple-text)",
                            fontWeight: "500",
                          }}
                        >
                          {c}
                        </span>
                      ))}
                    </div>
                  )}

                  {item.why_hidden && (
                    <div
                      style={{
                        fontSize: "11.5px",
                        color: "var(--fc-text-subtle)",
                        borderLeft: "2px solid var(--fc-border-light)",
                        paddingLeft: "9px",
                        lineHeight: "1.5",
                        marginBottom: "8px",
                      }}
                    >
                      {item.why_hidden}
                    </div>
                  )}

                  {item.suggested_applications?.length > 0 && (
                    <div>
                      <div
                        style={{
                          fontSize: "10px",
                          color: "var(--fc-text-subtle)",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                          marginBottom: "5px",
                        }}
                      >
                        Suggested applications
                      </div>
                      {item.suggested_applications.map((app, ai) => (
                        <div
                          key={ai}
                          style={{
                            display: "flex",
                            gap: "7px",
                            marginBottom: "3px",
                          }}
                        >
                          <div
                            style={{
                              width: "6px",
                              height: "6px",
                              borderRadius: "50%",
                              background: "#6C63FF",
                              flexShrink: 0,
                              marginTop: "6px",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              color: "var(--fc-text-primary)",
                              lineHeight: "1.5",
                            }}
                          >
                            {app}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Rare Skills */}
      {data.rare_skills?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "0.5px solid var(--fc-border-light)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "var(--fc-purple-text)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>⭐</span> Rare & Specialist Skills
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {data.rare_skills.map((item, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  padding: "10px 12px",
                  background: "var(--fc-bg-light)",
                  borderRadius: "8px",
                  border: "0.5px solid var(--fc-border-light)",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "var(--fc-purple-text)",
                    flexShrink: 0,
                    marginTop: "5px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color:"var(--fc-text-primary)",
                      marginBottom: "2px",
                    }}
                  >
                    {item.skill}
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "var(--fc-text-subtle)",
                      lineHeight: "1.5",
                    }}
                  >
                    {item.why_valuable}
                  </div>
                  {item.candidates?.length > 0 && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "var(--fc-purple-text)",
                        marginTop: "4px",
                      }}
                    >
                      {item.candidates.join(", ")}
                    </div>
                  )}
                </div>
                <span
                  style={{
                    fontSize: "10px",
                    padding: "3px 9px",
                    borderRadius: "100px",
                    fontWeight: "500",
                    flexShrink: 0,
                    background: "var(--fc-purple-light)",
                    color: "var(--fc-purple-text)",
                  }}
                >
                  Rare
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Recommendation */}
      {data.recommendation && (
        <div
          style={{
            background: "var(--fc-purple-light)",
            border: "0.5px solid var(--fc-purple-border)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "#6C63FF",
              marginBottom: "6px",
            }}
          >
            Connect IQ Recommendation
          </div>
          <div style={{ fontSize: "13px", color: "var(--fc-text-secondary)", lineHeight: "1.7" }}>
            {data.recommendation}
          </div>
        </div>
      )}
    </div>
  </div>
);

// ── Training Plan Result (UC4) ────────────────────────────────────────────────

const STEP_TYPE_STYLES = {
  course: { bg: "var(--fc-purple-light)", color: "var(--fc-purple-text)", label: "Course" },
  certification: { bg: "var(--fc-green-light)", color: "var(--fc-green-text)", label: "Certification" },
  mentorship: { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)", label: "Mentorship" },
  project: { bg: "var(--fc-cyan-light)", color: "var(--fc-cyan-text)", label: "Project" },
};

const TrainingPlanResult = ({ data }) => (
  <div style={{ fontSize: "13px", maxWidth: "100%" }}>
    {data.summary && (
      <p
        style={{
          color: "var(--fc-text-secondary)",
          marginBottom: "16px",
          lineHeight: "1.7",
          fontSize: "13.5px",
        }}
      >
        {data.summary}
      </p>
    )}

    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {(data.plans || []).map((plan, i) => (
        <div
          key={i}
          style={{
            background: "var(--fc-card-bg)",
            border: i === 0 ? "1px solid var(--fc-border-strong)" : "0.5px solid var(--fc-border-light)",
            borderRadius: "12px",
            padding: "16px 18px",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color:"var(--fc-text-primary)",
                }}
              >
                {plan.name}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#6C63FF",
                  fontWeight: "500",
                  marginTop: "2px",
                }}
              >
                {plan.current_role}
              </div>
            </div>
            <div style={{ textAlign: "right", flexShrink: 0 }}>
              <div style={{ fontSize: "10px", color: "var(--fc-text-subtle)" }}>
                Target skill
              </div>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color:"var(--fc-text-primary)",
                  marginTop: "2px",
                }}
              >
                {plan.target_skill}
              </div>
            </div>
          </div>

          {/* Why this person */}
          {plan.why_this_person && (
            <div
              style={{
                fontSize: "12px",
                color: "var(--fc-text-muted)",
                borderLeft: "2px solid #6C63FF",
                paddingLeft: "9px",
                lineHeight: "1.5",
                marginBottom: "12px",
              }}
            >
              {plan.why_this_person}
            </div>
          )}

          {/* Current strengths */}
          {plan.current_strengths?.length > 0 && (
            <div style={{ marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "10px",
                  color: "var(--fc-text-subtle)",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                  marginBottom: "5px",
                }}
              >
                Adjacent skills
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                {plan.current_strengths.map((s, si) => (
                  <span
                    key={si}
                    style={{
                      fontSize: "10.5px",
                      padding: "3px 9px",
                      borderRadius: "100px",
                      background: "var(--fc-green-light)",
                      color: "var(--fc-green-text)",
                      fontWeight: "500",
                    }}
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Training steps */}
          {plan.training_steps?.length > 0 && (
            <div style={{ marginBottom: "10px" }}>
              <div
                style={{
                  fontSize: "10px",
                  color: "var(--fc-text-subtle)",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                  marginBottom: "8px",
                }}
              >
                Training path
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "6px" }}
              >
                {plan.training_steps.map((step, si) => {
                  const st =
                    STEP_TYPE_STYLES[step.type] || STEP_TYPE_STYLES.course;
                  return (
                    <div
                      key={si}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                        padding: "9px 12px",
                        background: "var(--fc-bg-light)",
                        borderRadius: "8px",
                        border: "0.5px solid var(--fc-border-light)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: "500",
                          padding: "2px 3px",
                          color: "var(--fc-text-subtle)",
                          flexShrink: 0,
                          minWidth: "18px",
                          textAlign: "center",
                        }}
                      >
                        {si + 1}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "12.5px",
                            color:"var(--fc-text-primary)",
                            marginBottom: "2px",
                          }}
                        >
                          {step.title}
                        </div>
                        <div
                          style={{
                            fontSize: "11.5px",
                            color: "var(--fc-text-subtle)",
                            lineHeight: "1.5",
                          }}
                        >
                          {step.detail}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          gap: "4px",
                          flexShrink: 0,
                        }}
                      >
                        <span
                          style={{
                            fontSize: "10px",
                            padding: "2px 8px",
                            borderRadius: "100px",
                            fontWeight: "500",
                            background: st.bg,
                            color: st.color,
                          }}
                        >
                          {st.label}
                        </span>
                        {step.duration && (
                          <span style={{ fontSize: "10px", color: "var(--fc-text-subtle)" }}>
                            {step.duration}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Estimated time */}
          {plan.estimated_time && (
            <div
              style={{
                fontSize: "11.5px",
                color: "var(--fc-text-muted)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span>🕒</span> Estimated time to proficiency:{" "}
              <strong>{plan.estimated_time}</strong>
            </div>
          )}
        </div>
      ))}

      {/* Hiring recommendation */}
      {data.hiring_recommendation && (
        <div
          style={{
            background: "var(--fc-purple-light)",
            border: "0.5px solid var(--fc-purple-border)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "#6C63FF",
              marginBottom: "6px",
            }}
          >
            Hiring Recommendation
          </div>
          <div style={{ fontSize: "13px", color: "var(--fc-text-secondary)", lineHeight: "1.7" }}>
            {data.hiring_recommendation}
          </div>
        </div>
      )}
    </div>
  </div>
);

// ── Skill Gap Result (UC3) ────────────────────────────────────────────────────

const SEVERITY_STYLES = {
  critical: {
    dot: "var(--fc-red-text)",
    pill: { bg: "var(--fc-red-light)", color: "var(--fc-red-text)" },
    label: "Critical",
  },
  moderate: {
    dot: "var(--fc-amber-text)",
    pill: { bg: "var(--fc-amber-light)", color: "var(--fc-amber-text)" },
    label: "Moderate",
  },
};

const SkillGapResult = ({ data }) => (
  <div style={{ fontSize: "13px", maxWidth: "100%" }}>
    {/* Summary */}
    {data.summary && (
      <p
        style={{
          color: "var(--fc-text-secondary)",
          marginBottom: "16px",
          lineHeight: "1.7",
          fontSize: "13.5px",
        }}
      >
        {data.summary}
      </p>
    )}

    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {/* Gaps */}
      {data.gaps?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "1px solid var(--fc-border-strong)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color:"var(--fc-text-primary)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>⚠</span> Skill Gaps
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {data.gaps.map((g, i) => {
              const s = SEVERITY_STYLES[g.severity] || SEVERITY_STYLES.moderate;
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                    padding: "10px 12px",
                    background: "var(--fc-bg-light)",
                    borderRadius: "8px",
                    border: "0.5px solid var(--fc-border-light)",
                  }}
                >
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background: s.dot,
                      flexShrink: 0,
                      marginTop: "5px",
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color:"var(--fc-text-primary)",
                        marginBottom: "2px",
                      }}
                    >
                      {g.skill}
                    </div>
                    <div
                      style={{
                        fontSize: "11.5px",
                        color: "var(--fc-text-subtle)",
                        borderLeft: "2px solid var(--fc-border-light)",
                        paddingLeft: "9px",
                        lineHeight: "1.5",
                      }}
                    >
                      {g.description}
                    </div>
                    {g.people_count === 0 && (
                      <div
                        style={{
                          fontSize: "11px",
                          color: "var(--fc-red-text)",
                          marginTop: "4px",
                        }}
                      >
                        Nobody in your workforce has this skill
                      </div>
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: "10px",
                      padding: "3px 9px",
                      borderRadius: "100px",
                      fontWeight: "500",
                      flexShrink: 0,
                      background: s.pill.bg,
                      color: s.pill.color,
                    }}
                  >
                    {s.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Risks */}
      {data.risks?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "0.5px solid var(--fc-border-light)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "var(--fc-amber-text)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>⚡</span> Single Point of Failure
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {data.risks.map((r, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  padding: "10px 12px",
                  background: "var(--fc-bg-light)",
                  borderRadius: "8px",
                  border: "0.5px solid var(--fc-border-light)",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "var(--fc-amber-text)",
                    flexShrink: 0,
                    marginTop: "5px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color:"var(--fc-text-primary)",
                      marginBottom: "2px",
                    }}
                  >
                    {r.skill}
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "var(--fc-text-subtle)",
                      borderLeft: "2px solid var(--fc-border-light)",
                      paddingLeft: "9px",
                      lineHeight: "1.5",
                    }}
                  >
                    {r.description}
                  </div>
                  {r.candidates?.length > 0 && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "var(--fc-amber-text)",
                        marginTop: "4px",
                      }}
                    >
                      Only: {r.candidates.join(", ")}
                    </div>
                  )}
                </div>
                <span
                  style={{
                    fontSize: "10px",
                    padding: "3px 9px",
                    borderRadius: "100px",
                    fontWeight: "500",
                    flexShrink: 0,
                    background: "var(--fc-amber-light)",
                    color: "var(--fc-amber-text)",
                  }}
                >
                  Risk
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Strengths */}
      {data.strengths?.length > 0 && (
        <div
          style={{
            background: "var(--fc-card-bg)",
            border: "0.5px solid var(--fc-border-light)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "var(--fc-green-text)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <span>✓</span> Strengths
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {data.strengths.map((s, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  padding: "10px 12px",
                  background: "var(--fc-bg-light)",
                  borderRadius: "8px",
                  border: "0.5px solid var(--fc-border-light)",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "var(--fc-green-text)",
                    flexShrink: 0,
                    marginTop: "5px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontWeight: "500",
                      fontSize: "13px",
                      color:"var(--fc-text-primary)",
                      marginBottom: "2px",
                    }}
                  >
                    {s.skill}
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "var(--fc-text-subtle)",
                      borderLeft: "2px solid var(--fc-border-light)",
                      paddingLeft: "9px",
                      lineHeight: "1.5",
                    }}
                  >
                    {s.description}
                  </div>
                  {s.candidates?.length > 0 && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "var(--fc-green-text)",
                        marginTop: "4px",
                      }}
                    >
                      {s.people_count} people:{" "}
                      {s.candidates.slice(0, 3).join(", ")}
                      {s.candidates.length > 3
                        ? ` +${s.candidates.length - 3} more`
                        : ""}
                    </div>
                  )}
                </div>
                <span
                  style={{
                    fontSize: "10px",
                    padding: "3px 9px",
                    borderRadius: "100px",
                    fontWeight: "500",
                    flexShrink: 0,
                    background: "var(--fc-green-light)",
                    color: "var(--fc-green-text)",
                  }}
                >
                  {s.people_count} people
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Recommendation */}
      {data.recommendation && (
        <div
          style={{
            background: "var(--fc-purple-light)",
            border: "0.5px solid var(--fc-purple-border)",
            borderRadius: "12px",
            padding: "14px 18px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              fontWeight: "600",
              color: "#6C63FF",
              marginBottom: "6px",
            }}
          >
            Connect IQ Recommendation
          </div>
          <div style={{ fontSize: "13px", color: "var(--fc-text-secondary)", lineHeight: "1.7" }}>
            {data.recommendation}
          </div>
        </div>
      )}
    </div>
  </div>
);

const ComparisonResult = ({ data, navigate }) => {
  return (
    <div style={{ fontSize: "13px", maxWidth: "100%" }}>
      {data.summary && (
        <p style={{ color: "var(--fc-text-secondary)", marginBottom: "14px", lineHeight: "1.6" }}>
          {data.summary}
        </p>
      )}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${(data.candidates || []).length}, 1fr)`,
          gap: "10px",
        }}
      >
        {(data.candidates || []).map((c, i) => {
          const av = AVATAR_COLORS[i % AVATAR_COLORS.length];
          const badgeStyle = BADGE_STYLES[c.badge] || BADGE_STYLES["Good fit"];
          const availHrs = parseInt(c.availability);
          const dotColor =
            availHrs >= 30 ? "var(--fc-green-text)" : availHrs >= 15 ? "var(--fc-amber-text)" : "var(--fc-red-text)";
          const pillBg =
            availHrs >= 30 ? "var(--fc-green-light)" : availHrs >= 15 ? "var(--fc-amber-light)" : "var(--fc-red-light)";
          return (
            <div
              key={i}
              style={{
                background: "var(--fc-card-bg)",
                border: i === 0 ? "1px solid var(--fc-border-strong)" : "0.5px solid var(--fc-border-light)",
                borderRadius: "12px",
                padding: "14px",
              }}
            >
              {/* Top row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: "8px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: av.bg,
                      color: av.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "600",
                      flexShrink: 0,
                    }}
                  >
                    {initials(c.name)}
                  </div>
                  <div style={{ minWidth: 0 }}>
                    {c.user_slug ? (
                      <>
                        <div
                          onClick={() =>
                            window.open(
                              `/resources/details/${c.user_slug}`,
                              "_blank",
                            )
                          }
                          style={{
                            fontWeight: "500",
                            fontSize: "13.5px",
                            color:"var(--fc-text-primary)",
                            cursor: "pointer",
                            textDecoration: "underline",
                            textDecorationColor: "transparent",
                            transition: "text-decoration-color 0.15s",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.textDecorationColor = "var(--fc-text-primary)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.textDecorationColor = "transparent")
                          }
                        >
                          {c.name}
                        </div>
                        <div
                          style={{
                            fontSize: "11.5px",
                            color: "#6C63FF",
                            fontWeight: "500",
                          }}
                        >
                          {c.role}
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "13.5px",
                            color:"var(--fc-text-primary)",
                          }}
                        >
                          {c.name}
                        </div>
                        <div
                          style={{
                            fontSize: "11.5px",
                            color: "#6C63FF",
                            fontWeight: "500",
                          }}
                        >
                          {c.role}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      color:"var(--fc-text-primary)",
                    }}
                  >
                    {c.match_score}%
                  </div>
                  <div style={{ fontSize: "10px", color: "var(--fc-text-subtle)" }}>
                    match
                  </div>
                </div>
              </div>

              {/* Meta */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                  fontSize: "11.5px",
                  color: "var(--fc-text-muted)",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {c.location && c.location !== "N/A" && (
                    <span>📍 {c.location}</span>
                  )}
                  <span
                    style={{
                      fontSize: "10px",
                      padding: "2px 8px",
                      borderRadius: "100px",
                      fontWeight: "500",
                      background: badgeStyle.bg,
                      color: badgeStyle.color,
                    }}
                  >
                    {c.badge}
                  </span>
                </div>
                {c.availability &&
                  c.availability !== "N/A" &&
                  c.availability !== "0 hrs/wk" && (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "2px 8px",
                        borderRadius: "100px",
                        background: pillBg,
                        fontSize: "11px",
                        fontWeight: "500",
                        color: dotColor,
                      }}
                    >
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          background: dotColor,
                        }}
                      />
                      {c.availability}
                    </span>
                  )}
              </div>

              {/* Skills */}
              {c.skills?.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                    marginBottom: "10px",
                  }}
                >
                  {c.skills.slice(0, 4).map((s, si) => (
                    <span
                      key={si}
                      style={{
                        fontSize: "10.5px",
                        padding: "3px 8px",
                        borderRadius: "100px",
                        background: "var(--fc-green-light)",
                        color: "var(--fc-green-text)",
                        fontWeight: "500",
                      }}
                    >
                      {s}
                    </span>
                  ))}
                </div>
              )}

              {/* Strengths */}
              {c.strengths?.length > 0 && (
                <div style={{ marginBottom: "8px" }}>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "var(--fc-text-subtle)",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                      marginBottom: "5px",
                    }}
                  >
                    Strengths
                  </div>
                  {c.strengths.map((s, si) => (
                    <div
                      key={si}
                      style={{
                        display: "flex",
                        gap: "6px",
                        marginBottom: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: "7px",
                          height: "7px",
                          borderRadius: "50%",
                          background: "var(--fc-green-text)",
                          flexShrink: 0,
                          marginTop: "4px",
                        }}
                      />
                      <div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color:"var(--fc-text-primary)",
                          }}
                        >
                          {s.label}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "var(--fc-text-subtle)",
                            lineHeight: "1.4",
                          }}
                        >
                          {s.detail}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Gaps */}
              {c.gaps?.length > 0 && (
                <div style={{ marginBottom: "8px" }}>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "var(--fc-text-subtle)",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                      marginBottom: "5px",
                    }}
                  >
                    Gaps
                  </div>
                  {c.gaps.map((g, gi) => (
                    <div
                      key={gi}
                      style={{
                        display: "flex",
                        gap: "6px",
                        marginBottom: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: "7px",
                          height: "7px",
                          borderRadius: "50%",
                          background: "var(--fc-red-text)",
                          flexShrink: 0,
                          marginTop: "4px",
                        }}
                      />
                      <div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color:"var(--fc-text-primary)",
                          }}
                        >
                          {g.label}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "var(--fc-text-subtle)",
                            lineHeight: "1.4",
                          }}
                        >
                          {g.detail}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Verdict */}
              {c.verdict && (
                <div
                  style={{
                    background: "var(--fc-purple-light)",
                    border: "0.5px solid var(--fc-purple-border)",
                    borderRadius: "8px",
                    padding: "8px 10px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "10px",
                      fontWeight: "500",
                      color: "#6C63FF",
                      marginBottom: "3px",
                    }}
                  >
                    Connect IQ analysis
                  </div>
                  <div
                    style={{
                      fontSize: "11.5px",
                      color: "var(--fc-text-secondary)",
                      lineHeight: "1.5",
                    }}
                  >
                    {c.verdict}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const StructuredResult = ({ data, navigate }) => (
  <div style={{ fontSize: "13.5px", maxWidth: "100%" }}>
    {data.location_warning && data.location_warning_message && (
      <div
        style={{
          background: "var(--fc-amber-light)",
          borderRadius: "10px",
          padding: "10px 13px",
          color: "var(--fc-amber-text)",
          fontSize: "12px",
          marginBottom: "12px",
          display: "flex",
          gap: "7px",
          alignItems: "flex-start",
        }}
      >
        <span style={{ fontSize: "15px", flexShrink: 0 }}>⚠</span>
        <span>{data.location_warning_message}</span>
      </div>
    )}

    {data.summary && (
      <p style={{ color: "var(--fc-text-secondary)", marginBottom: "14px", lineHeight: "1.6" }}>
        {data.summary}
      </p>
    )}

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {(data.candidates || []).map((c, i) => {
        const av = AVATAR_COLORS[i % AVATAR_COLORS.length];
        const badgeStyle = BADGE_STYLES[c.badge] || BADGE_STYLES["Good fit"];
        return (
          <div
            key={i}
            style={{
              background: "var(--fc-card-bg)",
              border: i === 0 ? "1px solid var(--fc-border-strong)" : "0.5px solid var(--fc-border-light)",
              borderRadius: "12px",
              padding: "14px 18px",
            }}
          >
            {/* Top row */}
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "12px",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: av.bg,
                    color: av.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "13px",
                    fontWeight: "600",
                    flexShrink: 0,
                  }}
                >
                  {initials(c.name)}
                </div>
                <div style={{ minWidth: 0 }}>
                  {c.user_slug ? (
                    <>
                      <div
                        onClick={() =>
                          window.open(
                            `/resources/details/${c.user_slug}`,
                            "_blank",
                          )
                        }
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color:"var(--fc-text-primary)",
                          cursor: "pointer",
                          textDecoration: "underline",
                          textDecorationColor: "transparent",
                          transition: "text-decoration-color 0.15s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.textDecorationColor = "var(--fc-text-primary)")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.textDecorationColor = "transparent")
                        }
                      >
                        {c.name}
                      </div>
                      <div
                        onClick={() =>
                          window.open(
                            `/resources/details/${c.user_slug}`,
                            "_blank",
                          )
                        }
                        style={{
                          fontSize: "12px",
                          color: "#6C63FF",
                          fontWeight: "500",
                          cursor: "pointer",
                          textDecoration: "underline",
                          textDecorationColor: "transparent",
                          transition: "text-decoration-color 0.15s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.textDecorationColor = "#6C63FF")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.textDecorationColor = "transparent")
                        }
                      >
                        {c.role}
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color:"var(--fc-text-primary)",
                        }}
                      >
                        {c.name}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#6C63FF",
                          fontWeight: "500",
                        }}
                      >
                        {c.role}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  flexShrink: 0,
                }}
              >
                {c.firm_logo && (
                  <img
                    src={FIRM_IMG_BASE + c.firm_logo}
                    alt={c.firm_name || "Firm logo"}
                    title={c.firm_name || ""}
                    style={{
                      height: "32px",
                      width: "auto",
                      maxWidth: "70px",
                      objectFit: "contain",
                      flexShrink: 0,
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                )}
                <div style={{ textAlign: "right" }}>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color:"var(--fc-text-primary)",
                    }}
                  >
                    {c.match_score}%
                  </div>
                  <div style={{ fontSize: "10px", color: "var(--fc-text-subtle)" }}>
                    match
                  </div>
                </div>
              </div>
            </div>

            {/* Meta row: location left, availability pill right, badge */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "10px",
                fontSize: "12px",
                color: "var(--fc-text-muted)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                {c.location && c.location !== "N/A" && (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <span>📍</span>
                    {c.location}
                  </span>
                )}
                {c.badge && (
                  <span
                    style={{
                      fontSize: "10px",
                      padding: "3px 9px",
                      borderRadius: "100px",
                      fontWeight: "500",
                      background: badgeStyle.bg,
                      color: badgeStyle.color,
                    }}
                  >
                    {c.badge}
                  </span>
                )}
              </div>
              {c.availability &&
                c.availability !== "N/A" &&
                c.availability !== "0 hrs/wk" &&
                (() => {
                  const hrs = parseInt(c.availability);
                  const dotColor =
                    hrs >= 30 ? "var(--fc-green-text)" : hrs >= 15 ? "var(--fc-amber-text)" : "var(--fc-red-text)";
                  const pillBg =
                    hrs >= 30 ? "var(--fc-green-light)" : hrs >= 15 ? "var(--fc-amber-light)" : "var(--fc-red-light)";
                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "3px 9px",
                        borderRadius: "100px",
                        background: pillBg,
                        fontSize: "11px",
                        fontWeight: "500",
                        color: dotColor,
                        marginLeft: "auto",
                      }}
                    >
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          background: dotColor,
                          flexShrink: 0,
                        }}
                      />
                      {c.availability}
                    </span>
                  );
                })()}
            </div>

            {/* Skill pills */}
            {c.skills && c.skills.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginBottom: c.evidence ? "10px" : "0",
                }}
              >
                {c.skills.slice(0, 4).map((s, si) => (
                  <span
                    key={si}
                    style={{
                      fontSize: "11px",
                      padding: "4px 11px",
                      borderRadius: "100px",
                      background: "var(--fc-green-light)",
                      color: "var(--fc-green-text)",
                      fontWeight: "500",
                    }}
                  >
                    {s}
                  </span>
                ))}
                {c.skills.length > 4 && (
                  <span
                    style={{
                      fontSize: "11px",
                      padding: "4px 11px",
                      borderRadius: "100px",
                      background: "var(--fc-bg-light)",
                      color: "var(--fc-text-muted)",
                      fontWeight: "500",
                    }}
                  >
                    +{c.skills.length - 4} more
                  </span>
                )}
              </div>
            )}

            {/* Evidence */}
            {c.evidence && (
              <div
                style={{
                  fontSize: "11.5px",
                  color: "var(--fc-text-subtle)",
                  borderLeft: "2px solid var(--fc-border-light)",
                  paddingLeft: "9px",
                  lineHeight: "1.5",
                  marginBottom: c.rationale ? "10px" : "0",
                }}
              >
                {c.evidence}
              </div>
            )}

            {/* Why this person */}
            {c.rationale && (
              <div
                style={{
                  background: "var(--fc-purple-light)",
                  border: "0.5px solid var(--fc-purple-border)",
                  borderRadius: "8px",
                  padding: "9px 12px",
                  fontSize: "12px",
                  color: "var(--fc-text-secondary)",
                  lineHeight: "1.6",
                }}
              >
                <span
                  style={{
                    fontWeight: "500",
                    color: "#6C63FF",
                    marginRight: "6px",
                  }}
                >
                  Connect IQ analysis
                </span>
                {c.rationale}
              </div>
            )}
          </div>
        );
      })}
    </div>

    {data.gap_message && (
      <div
        style={{
          background: "var(--fc-amber-light)",
          borderRadius: "10px",
          padding: "10px 13px",
          color: "var(--fc-amber-text)",
          fontSize: "12px",
          marginTop: "12px",
          display: "flex",
          gap: "7px",
          alignItems: "flex-start",
        }}
      >
        <span style={{ fontSize: "15px", flexShrink: 0 }}>⚠</span>
        <span>{data.gap_message}</span>
      </div>
    )}
  </div>
);

export default function ConnectIQPage() {
  const { user, userSlug } = useAuth();
  const navigate = useNavigate();
  const parsedUser = user || null;
  const userInitials = user?.first_name
    ? initials(`${user.first_name} ${user.last_name}`)
    : "ME";
  const { role, isRM } = useRole();

  const [scope, setScope] = useState("my_company");
  const [sessions, setSessions] = useState([]);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  const EXAMPLES = [
    "Find a project manager with Oil and Gas experience in Asia",
    "I need a team of 4 for a 6-month healthcare software project in Nova Scotia",
    "Who are our strongest React developers available full time?",
    "Find senior backend developers with 5+ years experience",
  ];

  useEffect(() => {
    if (!userSlug) {
      navigate("/login");
      return;
    }
    if (role && !isRM) {
      navigate("/dashboard");
      return;
    }
    setSessions([]);
    setSessionId(null);
    setMessages([]);
    setMessage("");
    loadSessions();
  }, [userSlug, role]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        Math.min(textareaRef.current.scrollHeight, 120) + "px";
    }
  }, [message]);

  const loadSessions = async () => {
    const res = await connectiqGetSessions(userSlug);
    if (res?.data?.status === 1) setSessions(res.data.sessions || []);
  };

  const parseMessages = (rawMessages) =>
    (rawMessages || []).map((msg) => {
      if (msg.role === "assistant") {
        try {
          const json = JSON.parse(msg.content);
          if (json && json.type === "training_plan")
            return { role: "assistant", type: "training_plan", data: json };
          if (json && json.type === "skill_gap")
            return { role: "assistant", type: "skill_gap", data: json };
          if (json && json.type === "hidden_skills")
            return { role: "assistant", type: "hidden_skills", data: json };
          if (json && json.type === "new_services")
            return { role: "assistant", type: "new_services", data: json };
          if (json && json.candidates && json.type === "comparison")
            return { role: "assistant", type: "comparison", data: json };
          if (json && json.candidates)
            return { role: "assistant", type: "structured", data: json };
        } catch (e) {}
        return { role: "assistant", type: "text", content: msg.content };
      }
      return { role: "user", content: msg.content };
    });

  const loadSession = async (sid) => {
    setIsLoadingHistory(true);
    setSessionId(sid);
    setMessages([]);
    const res = await connectiqGetMessages(userSlug, sid);
    if (res?.data?.status === 1) setMessages(parseMessages(res.data.messages));
    setIsLoadingHistory(false);
  };

  const startNewChat = () => {
    setSessionId(null);
    setMessages([]);
    setMessage("");
    setMobileSidebarOpen(false);
    textareaRef.current?.focus();
  };

  const handleSend = useCallback(
    async (overrideMessage) => {
      const text = (overrideMessage || message).trim();
      if (!text || isLoading) return;
      setMessages((prev) => [...prev, { role: "user", content: text }]);
      setMessage("");
      setIsLoading(true);
      const res = await connectiqChat(userSlug, text, scope, sessionId);
      if (res?.data?.status === 1) {
        const aiMsg =
          res.data.type === "training_plan"
            ? { role: "assistant", type: "training_plan", data: res.data.data }
            : res.data.type === "skill_gap"
              ? { role: "assistant", type: "skill_gap", data: res.data.data }
              : res.data.type === "hidden_skills"
                ? {
                    role: "assistant",
                    type: "hidden_skills",
                    data: res.data.data,
                  }
                : res.data.type === "new_services"
                  ? {
                      role: "assistant",
                      type: "new_services",
                      data: res.data.data,
                    }
                  : res.data.type === "comparison"
                    ? {
                        role: "assistant",
                        type: "comparison",
                        data: res.data.data,
                      }
                    : res.data.type === "structured"
                      ? {
                          role: "assistant",
                          type: "structured",
                          data: res.data.data,
                        }
                      : {
                          role: "assistant",
                          type: "text",
                          content: res.data.message,
                        };
        setMessages((prev) => [...prev, aiMsg]);
        if (!sessionId) setSessionId(res.data.session_id);
        loadSessions();
      } else {
        setMessages((prev) => [
          ...prev,
          {
            role: "assistant",
            type: "text",
            content:
              res?.data?.message || "Something went wrong. Please try again.",
          },
        ]);
      }
      setIsLoading(false);
      textareaRef.current?.focus();
    },
    [message, isLoading, userSlug, scope, sessionId],
  );

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleDeleteSession = async (e, sid) => {
    e.stopPropagation();
    await connectiqDeleteSession(userSlug, sid);
    if (sessionId === sid) startNewChat();
    loadSessions();
  };

  const grouped = groupSessionsByDate(sessions);
  const currentTitle = sessionId
    ? sessions.find((s) => s.session_id === sessionId)?.session_title
    : null;

  return (
    <div
        style={{
          display: "flex",
          height: "calc(100vh - 100px)",
          minHeight: "560px",
          width: "100%",
          fontFamily: "inherit",
          background: "var(--fc-card-bg)",
          border: "0.5px solid var(--fc-border-light)",
          borderRadius: "14px",
          overflow: "hidden",
        }}
      >
        {/* Mobile backdrop — tap to dismiss the chat history drawer */}
        {mobileSidebarOpen && (
          <div className="d-md-none" onClick={() => setMobileSidebarOpen(false)}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 499, backdropFilter: "blur(2px)" }} />
        )}

        {/* Sidebar */}
        <div
          className={`fc-connectiq-sidebar${mobileSidebarOpen ? " mobile-open" : ""}`}
          style={{
            width: "250px",
            background: "var(--fc-bg-light)",
            borderRight: "0.5px solid var(--fc-border-light)",
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
          }}
        >
          <div style={{ padding: "18px 16px 14px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "9px",
                marginBottom: "16px",
              }}
            >
              <div
                style={{
                  width: "26px",
                  height: "26px",
                  borderRadius: "7px",
                  background: "#171717",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: "600",
                  flexShrink: 0,
                }}
              >
                <i className="fa-solid fa-robot" style={{ fontSize: "11px" }} />
              </div>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color:"var(--fc-text-primary)",
                  letterSpacing: "-0.2px",
                  flex: 1,
                }}
              >
                ConnectIQ
              </span>
              <button
                onClick={() => setMobileSidebarOpen(false)}
                className="d-md-none"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "var(--fc-text-subtle)",
                  fontSize: "16px",
                  padding: "4px",
                  lineHeight: 1,
                }}
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <button
              onClick={startNewChat}
              style={{
                width: "100%",
                padding: "9px 12px",
                borderRadius: "9px",
                border: "none",
                background: "#171717",
                color: "#fff",
                fontSize: "12.5px",
                fontWeight: "500",
                cursor: "pointer",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}
            >
              + New chat
            </button>
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: "16px 0 0" }}>
            {["Today", "Yesterday", "Earlier"].map((group) =>
              grouped[group].length > 0 ? (
                <div key={group}>
                  <div
                    style={{
                      fontSize: "10.5px",
                      color: "var(--fc-text-subtle)",
                      padding: "6px 16px 6px",
                      letterSpacing: "0.3px",
                      fontWeight: "500",
                    }}
                  >
                    {group}
                  </div>
                  {grouped[group].map((s) => (
                    <div
                      key={s.session_id}
                      onClick={() => { loadSession(s.session_id); setMobileSidebarOpen(false); }}
                      style={{
                        margin: "0 8px 2px",
                        padding: "8px 10px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        background:
                          sessionId === s.session_id ? "var(--fc-card-bg)" : "transparent",
                        boxShadow:
                          sessionId === s.session_id
                            ? "0 0 0 0.5px var(--fc-border)"
                            : "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "9px",
                      }}
                    >
                      <div
                        style={{
                          width: "5px",
                          height: "5px",
                          borderRadius: "50%",
                          background:
                            sessionId === s.session_id ? "#6C63FF" : "var(--fc-text-hint)",
                          flexShrink: 0,
                        }}
                      />
                      <span
                        style={{
                          fontSize: "12.5px",
                          color:
                            sessionId === s.session_id ? "var(--fc-text-primary)" : "var(--fc-text-muted)",
                          fontWeight:
                            sessionId === s.session_id ? "500" : "400",
                          flex: 1,
                          minWidth: 0,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {s.session_title}
                      </span>
                      <button
                        onClick={(e) => handleDeleteSession(e, s.session_id)}
                        style={{
                          background: "none",
                          border: "none",
                          color: "var(--fc-text-hint)",
                          cursor: "pointer",
                          fontSize: "13px",
                          lineHeight: 1,
                          flexShrink: 0,
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              ) : null,
            )}
            {sessions.length === 0 && (
              <div
                style={{ padding: "16px", fontSize: "12px", color: "var(--fc-text-hint)" }}
              >
                No previous chats
              </div>
            )}
          </div>
        </div>

        {/* Main */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          {/* Top bar */}
          <div
            style={{
              height: "56px",
              display: "flex",
              alignItems: "center",
              padding: "0 24px",
              gap: "14px",
              borderBottom: "0.5px solid var(--fc-border-light)",
              flexShrink: 0,
            }}
          >
            <button
              onClick={() => setMobileSidebarOpen(true)}
              className="d-md-none"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color:"var(--fc-text-primary)",
                fontSize: "16px",
                padding: "4px",
                lineHeight: 1,
                flexShrink: 0,
              }}
            >
              <i className="fa-solid fa-bars" />
            </button>
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color:"var(--fc-text-primary)",
                flex: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {currentTitle || "New chat"}
            </span>
            <div
              style={{
                display: "flex",
                background: "var(--fc-bg-light)",
                borderRadius: "100px",
                padding: "3px",
              }}
            >
              {["my_company", "full_network"].map((s) => (
                <button
                  key={s}
                  onClick={() => setScope(s)}
                  style={{
                    fontSize: "12px",
                    padding: "5px 14px",
                    borderRadius: "100px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "500",
                    background: scope === s ? "#171717" : "transparent",
                    color: scope === s ? "#fff" : "var(--fc-text-subtle)",
                    transition: "all 0.15s",
                  }}
                >
                  {s === "my_company" ? "My company" : "Full network"}
                </button>
              ))}
            </div>
          </div>

          {/* Thread */}
          <div
            className="fc-connectiq-thread"
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "32px 40px",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            {isLoadingHistory && (
              <div
                style={{
                  textAlign: "center",
                  color: "var(--fc-text-hint)",
                  fontSize: "13px",
                  marginTop: "40px",
                }}
              >
                Loading conversation...
              </div>
            )}

            {!isLoadingHistory && messages.length === 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  textAlign: "center",
                  padding: "40px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "14px",
                    background: "#171717",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#fff",
                    marginBottom: "18px",
                  }}
                >
                  <i className="fa-solid fa-robot" style={{ fontSize: "18px" }} />
                </div>
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "500",
                    color:"var(--fc-text-primary)",
                    marginBottom: "8px",
                  }}
                >
                  ConnectIQ
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "var(--fc-text-subtle)",
                    lineHeight: "1.6",
                    maxWidth: "380px",
                    marginBottom: "26px",
                  }}
                >
                  Your AI talent assistant. Describe who you're looking for and
                  I'll find the best candidates from your{" "}
                  {scope === "my_company" ? "company" : "full network"}.
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    width: "100%",
                    maxWidth: "440px",
                  }}
                >
                  {EXAMPLES.map((ex, i) => (
                    <button
                      key={i}
                      onClick={() => handleSend(ex)}
                      style={{
                        padding: "11px 16px",
                        background: "var(--fc-bg-light)",
                        border: "0.5px solid var(--fc-border-light)",
                        borderRadius: "12px",
                        color: "var(--fc-text-secondary)",
                        fontSize: "13px",
                        cursor: "pointer",
                        textAlign: "left",
                      }}
                    >
                      {ex}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {!isLoadingHistory &&
              messages.map((msg, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "flex-start",
                    flexDirection: msg.role === "user" ? "row-reverse" : "row",
                    width:
                      msg.type === "structured" ||
                      msg.type === "comparison" ||
                      msg.type === "skill_gap" ||
                      msg.type === "training_plan" ||
                      msg.type === "hidden_skills" ||
                      msg.type === "new_services"
                        ? "100%"
                        : "auto",
                  }}
                >
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "10.5px",
                      fontWeight: "600",
                      background: msg.role === "user" ? "var(--fc-bg-light)" : "#171717",
                      color: msg.role === "user" ? "var(--fc-text-muted)" : "#fff",
                    }}
                  >
                    {msg.role === "user" ? userInitials : <i className="fa-solid fa-robot" />}
                  </div>
                  {msg.type === "training_plan" ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <TrainingPlanResult data={msg.data} />
                    </div>
                  ) : msg.type === "hidden_skills" ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <HiddenSkillsResult data={msg.data} />
                    </div>
                  ) : msg.type === "new_services" ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <NewServicesResult data={msg.data} />
                    </div>
                  ) : msg.type === "skill_gap" ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <SkillGapResult data={msg.data} />
                    </div>
                  ) : msg.type === "comparison" ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <ComparisonResult data={msg.data} navigate={navigate} />
                    </div>
                  ) : msg.type === "structured" ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <StructuredResult data={msg.data} navigate={navigate} />
                    </div>
                  ) : (
                    <div
                      style={{
                        maxWidth: "72%",
                        padding: "12px 16px",
                        borderRadius:
                          msg.role === "user"
                            ? "16px 4px 16px 16px"
                            : "4px 16px 16px 16px",
                        background: msg.role === "user" ? "#171717" : "var(--fc-bg-light)",
                        color: msg.role === "user" ? "#fff" : "var(--fc-text-primary)",
                        fontSize: "13.5px",
                        lineHeight: "1.6",
                      }}
                    >
                      {msg.role === "user"
                        ? msg.content
                        : renderTextContent(msg.content)}
                    </div>
                  )}
                </div>
              ))}

            {isLoading && (
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "#171717",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "10.5px",
                    fontWeight: "600",
                    color: "#fff",
                    flexShrink: 0,
                  }}
                >
                  <i className="fa-solid fa-robot" style={{ fontSize: "18px" }} />
                </div>
                <div
                  style={{
                    padding: "13px 16px",
                    background: "var(--fc-bg-light)",
                    borderRadius: "4px 16px 16px 16px",
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  {[0, 1, 2].map((i) => (
                    <div
                      key={i}
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: "var(--fc-text-hint)",
                        animation: `ciq-bounce 1.2s ease-in-out ${i * 0.2}s infinite`,
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Composer */}
          <div
            style={{
              padding: "16px 24px 22px",
              borderTop: "0.5px solid var(--fc-border-light)",
              flexShrink: 0,
            }}
          >
            {scope === "full_network" && (
              <div
                style={{ fontSize: "11px", color: "var(--fc-text-subtle)", marginBottom: "8px" }}
              >
                ⚠ Full network — candidate names will be hidden in results
              </div>
            )}
            <div
              style={{
                background: "var(--fc-bg-light)",
                borderRadius: "16px",
                display: "flex",
                alignItems: "flex-end",
                gap: "10px",
                padding: "12px 12px 12px 18px",
              }}
            >
              <textarea
                ref={textareaRef}
                rows={1}
                placeholder="Describe what you're looking for..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={isLoading}
                style={{
                  flex: 1,
                  background: "transparent",
                  border: "none",
                  outline: "none",
                  color:"var(--fc-text-primary)",
                  fontSize: "13.5px",
                  resize: "none",
                  lineHeight: "1.5",
                  maxHeight: "120px",
                  fontFamily: "inherit",
                }}
              />
              <button
                onClick={() => handleSend()}
                disabled={!message.trim() || isLoading}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "10px",
                  background:
                    !message.trim() || isLoading ? "var(--fc-border-light)" : "#171717",
                  border: "none",
                  color: !message.trim() || isLoading ? "var(--fc-text-subtle)" : "#fff",
                  cursor:
                    !message.trim() || isLoading ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  fontSize: "15px",
                }}
              >
                ↑
              </button>
            </div>
          </div>
        </div>
      <style>{`
        @keyframes ciq-bounce {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-5px); opacity: 1; }
        }
      `}</style>
    </div>
  );
};


